import React from "react";
import PropTypes from "prop-types";
import { FaPlus } from "react-icons/fa";

import "./AddButton.scss";

const AddButton = props => {
  const { onClick, children } = props;

  return (
    <button className="addButton" onClick={onClick}>
      <FaPlus />
      {children}
    </button>
  );
};

AddButton.propTypes = {
  onClick: PropTypes.func
};

export default AddButton;
